import * as endpoints from '../helpers/endpoints';
import moment from 'moment';

export default {
    pastDueNeedsReviewEvents: userInfo => {
        const userQuery = userInfo.TrustingUser
            ? `filters[Task][userId][in]=${
                  userInfo.id
              }&filters[Task][userId][in]=${userInfo.TrustingUser.id}`
            : `filters[Task][userId][eq]=${userInfo.id}`;
        return `${
            endpoints.EVENT_TASK_PATH
        }?${userQuery}&filters[Task][resourceType][eq]=Event&fields[Task][]=createdAt&fields[Task][]=updatedAt&filters[Task][status][eq]=Incomplete&filters[Task][action][eq]=Review&filters[Task][updatedAt][lt]=${moment()
            .subtract(7, 'days')
            .format(
                'YYYY-MM-DD'
            )}&fields[Event][]=id&fields[Event][]=name&fields[Task][]=dueDate&fields[Event][]=endDate`;
    },
    pastDueNeedsReviewAfterActions: userInfo => {
        const userQuery = userInfo.TrustingUser
            ? `filters[Task][userId][in]=${
                  userInfo.id
              }&filters[Task][userId][in]=${userInfo.TrustingUser.id}`
            : `filters[Task][userId][eq]=${userInfo.id}`;
        return `${
            endpoints.EVENT_TASK_PATH
        }?&fields[Task][]=createdAt&fields[Task][]=updatedAt&filters[Task][resourceType][eq]=EventReport&${userQuery}&filters[Task][status][eq]=Incomplete&filters[Task][action][eq]=Review&filters[Task][updatedAt][lt]=${moment()
            .subtract(7, 'days')
            .format(
                'YYYY-MM-DD'
            )}&fields[EventReport][]=id&fields[EventReport][]=subStatus&fields[Task][]=dueDate&fields[Task][]=action&include[]=EventReport.Event`;
    },
    pastDueReturnedForEditEvents: userInfo => {
        const userQuery = userInfo.TrustingUser
            ? `filters[Task][userId][in]=${
                  userInfo.id
              }&filters[Task][userId][in]=${userInfo.TrustingUser.id}`
            : `filters[Task][userId][eq]=${userInfo.id}`;
        return `${
            endpoints.EVENT_TASK_PATH
        }?${userQuery}&filters[Task][resourceType][eq]=Event&fields[Task][]=createdAt&fields[Task][]=updatedAt&filters[Task][status][eq]=Incomplete&filters[Task][action][eq]=Info&filters[Task][updatedAt][lt]=${moment()
            .subtract(7, 'days')
            .format(
                'YYYY-MM-DD'
            )}&fields[Event][]=id&fields[Event][]=name&fields[Task][]=dueDate&fields[Event][]=endDate`;
    },
    pastDueReturnedForEditAfterActions: userInfo => {
        const userQuery = userInfo.TrustingUser
            ? `filters[Task][userId][in]=${
                  userInfo.id
              }&filters[Task][userId][in]=${userInfo.TrustingUser.id}`
            : `filters[Task][userId][eq]=${userInfo.id}`;
        return `${
            endpoints.EVENT_TASK_PATH
        }?&fields[Task][]=createdAt&fields[Task][]=updatedAt&filters[Task][resourceType][eq]=EventReport&${userQuery}&filters[Task][status][eq]=Incomplete&filters[Task][action][eq]=Info&filters[Task][updatedAt][lt]=${moment()
            .subtract(3, 'days')
            .format(
                'YYYY-MM-DD'
            )}&fields[EventReport][]=id&fields[EventReport][]=subStatus&fields[Task][]=dueDate&fields[Task][]=action&include[]=EventReport.Event`;
    },
    pastDueIncompleteAfterAction: userInfo => {
        const userQuery = userInfo.TrustingUser
            ? `filters[EventReport][userId][in]=${
                  userInfo.id
              }&filters[EventReport][userId][in]=${userInfo.TrustingUser.id}`
            : `filters[EventReport][userId][eq]=${userInfo.id}`;
        return `${
            endpoints.EVENT_REPORT_PATH
        }?${userQuery}&filters[EventReport][status][in][]=Incomplete&filters[EventReport][status][in][]=Pending&filters[Event][status][in][]=Approved&filters[Event][endDate][lte]=${moment()
            .subtract(7, 'days')
            .format(
                'YYYY-MM-DD'
            )}&fields[Event][]=id&fields[Event][]=name&fields[Event][]=createdAt&fields[Event][]=endDate`;
    },
    incompleteEvents: userInfo => {
        const userQuery = userInfo.TrustingUser
            ? `filters[Event][createdById][in]=${
                  userInfo.id
              }&filters[Event][createdById][in]=${userInfo.TrustingUser.id}`
            : `filters[Event][createdById][eq]=${userInfo.id}`;
        return `${
            endpoints.EVENT_SEARCH_PATH
        }?${userQuery}&filters[Event][status][eq]=Incomplete&fields[Event][]=id&fields[Event][]=name&fields[Event][]=createdAt&fields[Event][]=endDate`;
    },
    incompleteAfterActions: userInfo => {
        const userQuery = userInfo.TrustingUser
            ? `filters[EventReport][createdById][in]=${
                  userInfo.id
              }&filters[EventReport][createdById][in]=${
                  userInfo.TrustingUser.id
              }`
            : `filters[EventReport][createdById][eq]=${userInfo.id}`;
        return `${
            endpoints.EVENT_REPORT_PATH
        }?${userQuery}&filters[EventReport][status][in][]=Incomplete&filters[EventReport][status][in][]=Pending&filters[Event][status][in][]=Approved&filters[Event][endDate][gt]=${moment()
            .subtract(7, 'days')
            .format(
                'YYYY-MM-DD'
            )}&fields[Event][]=id&fields[Event][]=name&fields[Event][]=endDate`;
    },
    incompleteAssignedAfterActions: userInfo => {
        const userQuery = userInfo.TrustingUser
            ? `filters[EventReport][userId][in]=${
                  userInfo.id
              }&filters[EventReport][userId][in]=${
                  userInfo.TrustingUser.id
              }&filters[EventReport][createdById][ne]=${
                  userInfo.id
              }&filters[EventReport][createdById][ne]=${
                  userInfo.TrustingUser.id
              }`
            : `filters[EventReport][userId][eq]=${
                  userInfo.id
              }&filters[EventReport][createdById][ne]=${userInfo.id}`;
        return `${
            endpoints.EVENT_REPORT_PATH
        }?${userQuery}&filters[EventReport][status][in][]=Incomplete&filters[EventReport][status][in][]=Pending&filters[Event][status][in][]=Approved&filters[Event][endDate][gt]=${moment()
            .subtract(7, 'days')
            .format(
                'YYYY-MM-DD'
            )}&fields[Event][]=id&fields[Event][]=name&fields[Event][]=endDate`;
    },
    needsReviewEvents: userInfo => {
        const userQuery = userInfo.TrustingUser
            ? `filters[Task][userId][in]=${
                  userInfo.id
              }&filters[Task][userId][in]=${userInfo.TrustingUser.id}`
            : `filters[Task][userId][eq]=${userInfo.id}`;
        return `${
            endpoints.EVENT_TASK_PATH
        }?&fields[Task][]=createdAt&fields[Task][]=updatedAt&filters[Task][resourceType][eq]=Event&${userQuery}&filters[Task][status][eq]=Incomplete&filters[Task][action][eq]=Review&filters[Task][updatedAt][gte]=${moment()
            .subtract(7, 'days')
            .format(
                'YYYY-MM-DD'
            )}&fields[Event][]=id&fields[Event][]=name&fields[Task][]=dueDate&fields[Event][]=endDate&`;
    },
    needsReviewAfterActions: userInfo => {
        const userQuery = userInfo.TrustingUser
            ? `filters[Task][userId][in]=${
                  userInfo.id
              }&filters[Task][userId][in]=${userInfo.TrustingUser.id}`
            : `filters[Task][userId][eq]=${userInfo.id}`;
        return `${
            endpoints.EVENT_TASK_PATH
        }?&fields[Task][]=createdAt&fields[Task][]=updatedAt&filters[Task][resourceType][eq]=EventReport&${userQuery}&filters[Task][status][eq]=Incomplete&filters[Task][action][not]=Info&filters[Task][updatedAt][gte]=${moment()
            .subtract(7, 'days')
            .format(
                'YYYY-MM-DD'
            )}&fields[EventReport][]=id&fields[Task][]=dueDate&include[]=EventReport.Event`;
    },
    pendingApprovalEvents: userInfo => {
        const userQuery = userInfo.TrustingUser
            ? `filters[Event][createdById][in]=${
                  userInfo.id
              }&filters[Event][createdById][in]=${userInfo.TrustingUser.id}`
            : `filters[Event][createdById][eq]=${userInfo.id}`;
        return `${
            endpoints.EVENT_SEARCH_PATH
        }?${userQuery}&filters[Event][status][eq]=Unapproved&fields[Event][]=id&fields[Event][]=name&fields[Event][]=createdAt&fields[Event][]=updatedAt&fields[Event][]=endDate`;
    },
    pendingApprovalAfterActions: userInfo => {
        const userQuery = userInfo.TrustingUser
            ? `filters[EventReport][userId][in]=${
                  userInfo.id
              }&filters[EventReport][userId][in]=${userInfo.TrustingUser.id}`
            : `filters[EventReport][userId][eq]=${userInfo.id}`;
        return `${
            endpoints.EVENT_SEARCH_PATH
        }?${userQuery}&filters[Event][status][eq]=Approved&filters[EventReport][status][eq]=Unapproved&fields[Event][]=id&fields[EventReport][]=id&fields[Event][]=name&fields[Event][]=endDate&fields[Event][]=createdAt&fields[Event][]=updatedAt`;
    },
    returnedForEditEvents: userInfo => {
        const userQuery = userInfo.TrustingUser
            ? `filters[Task][userId][in]=${
                  userInfo.id
              }&filters[Task][userId][in]=${userInfo.TrustingUser.id}`
            : `filters[Task][userId][eq]=${userInfo.id}`;
        return `${
            endpoints.EVENT_TASK_PATH
        }?filters[Task][resourceType][eq]=Event&${userQuery}&filters[Task][status][eq]=Incomplete&filters[Task][action][eq]=Info&fields[Event][]=id&fields[Event][]=name&fields[Event][]=createdAt`;
    },
    returnedForEditAfterActions: userInfo => {
        const userQuery = userInfo.TrustingUser
            ? `filters[Task][userId][in]=${
                  userInfo.id
              }&filters[Task][userId][in]=${userInfo.TrustingUser.id}`
            : `filters[Task][userId][eq]=${userInfo.id}`;
        return `${
            endpoints.EVENT_TASK_PATH
        }?filters[Task][resourceType][eq]=EventReport&${userQuery}&filters[Task][status][eq]=Incomplete&filters[Task][action][eq]=Info&fields[EventReport][]=id&include[]=EventReport.Event&fields[Task][]=dueDate`;
    },
    rejectedEvents: userInfo => {
        const userQuery = userInfo.TrustingUser
            ? `filters[Event][createdById][in]=${
                  userInfo.id
              }&filters[Event][createdById][in]=${userInfo.TrustingUser.id}`
            : `filters[Event][createdById][eq]=${userInfo.id}`;
        return `${
            endpoints.EVENT_SEARCH_PATH
        }?${userQuery}&filters[Event][status][eq]=Rejected&filters[Event][updatedAt][gt]=${moment()
            .subtract(1, 'days')
            .format(
                'YYYY-MM-DD'
            )}&fields[Event][]=id&fields[Event][]=name&fields[Event][]=createdAt`;
    }
};



// WEBPACK FOOTER //
// ./src/helpers/alerts-tasks-urls.js